module.exports = __webpack_public_path__ + "img/3Webデータベースシステム入門5_7_3.8ff2a1d4.png";